import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-grammar-checker-features',
  templateUrl: './grammar-checker-features.component.html',
  styleUrls: ['./grammar-checker-features.component.scss']
})
export class GrammarCheckerFeaturesComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) { }

  ngOnInit() {
    this.titleService.setTitle("Trinka AI｜打造完美寫作，讓文法檢查工具助你一臂之力");
    this.metaTagService.updateTag({ name: 'description', content: " 用 Trinka AI 提升你的寫作品質——這是一款結合 AI 技術的文法檢查與語言優化工具，幫助你改善語氣、結構、用詞與可讀性。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka AI｜打造完美寫作，讓文法檢查工具助你一臂之力" });
    this.metaTagService.updateTag({ property: 'og:description', content: " 用 Trinka AI 提升你的寫作品質——這是一款結合 AI 技術的文法檢查與語言優化工具，幫助你改善語氣、結構、用詞與可讀性。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/WritingMoreEffective.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka AI｜打造完美寫作，讓文法檢查工具助你一臂之力' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: " 用 Trinka AI 提升你的寫作品質——這是一款結合 AI 技術的文法檢查與語言優化工具，幫助你改善語氣、結構、用詞與可讀性。" });  
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/WritingMoreEffective.png' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/feaures/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/grammar-checker' });
    
    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

}
